import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useSearchParams } from 'react-router';

import { useProject } from '../projects/context';
import { projectKeys, useProjectApi } from '../projects/useProjectApi';

export function AreaMaklerFilterToggle() {
  const [params] = useSearchParams();
  const [open, setOpen] = useState(() => params.has('gebiet') || params.has('makler'));
  return (
    <div className="hub-filter-toggle">
      <button type="button" className="btn btn-small btn-ghost" aria-expanded={open} onClick={() => setOpen((v) => !v)}>
        {open ? 'Filter ausblenden' : 'Nach Gebiet oder Makler filtern'}
      </button>
      {open && <AreaMaklerFilter />}
    </div>
  );
}

// Filter nach Gebiet und Makler (URL-Parameter gebiet/makler), z. B. im Posteingang.
export function AreaMaklerFilter({ showMakler = true }: { showMakler?: boolean }) {
  const { project, can } = useProject();
  const papi = useProjectApi();
  const [params, setParams] = useSearchParams();
  const areas = useQuery({
    queryKey: [...projectKeys.areas(project.id), 'active'],
    queryFn: ({ signal }) => papi.projectAreas(false, signal),
    enabled: can('area.read'),
    staleTime: 5 * 60_000,
  });
  const members = useQuery({ queryKey: projectKeys.members(project.id), queryFn: ({ signal }) => papi.members(signal), staleTime: 5 * 60_000 });
  const makler = [...new Map((members.data?.items ?? []).filter((m) => m.role_key === 'FIELD_SALES' && m.status === 'ACTIVE').map((m) => [m.user_id, m])).values()];
  const set = (key: string, value: string) => {
    const next = new URLSearchParams(params);
    if (value) next.set(key, value);
    else next.delete(key);
    setParams(next);
  };
  return (
    <div className="hub-filters" role="group" aria-label="Filter nach Gebiet und Makler">
      {can('area.read') && (
        <label className="field">
          <span>Gebiet</span>
          <select value={params.get('gebiet') ?? ''} onChange={(e) => set('gebiet', e.target.value)}>
            <option value="">Alle Gebiete</option>
            {(areas.data?.items ?? []).map((a) => (
              <option key={a.id} value={a.id}>
                {a.name}
              </option>
            ))}
          </select>
        </label>
      )}
      {showMakler && (
        <label className="field">
          <span>Makler</span>
          <select value={params.get('makler') ?? ''} onChange={(e) => set('makler', e.target.value)}>
            <option value="">Alle Makler</option>
            {makler.map((m) => (
              <option key={m.user_id} value={m.user_id}>
                {m.first_name} {m.last_name}
              </option>
            ))}
          </select>
        </label>
      )}
    </div>
  );
}
